export default {
  ACTIVE: 'active',
  REGISTRATION: 'registration',
  AFFILIATION: 'affiliation',
  REFUSED: 'refused',
  SUSPENDED: 'suspended',
  BLOCKED: 'blocked',
  INACTIVE: 'inactive',
};
